/**
 * overriding the google method of adding additional css.
 */
(function (MOVE) {
    "use strict";
    var init = function () {
        var head = document.getElementsByTagName('head')[0];

        // Save the original method
        var insertBefore = head.insertBefore;

        // Replace it!
        head.insertBefore = function (newElement, referenceElement) {

            if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0) {
                return;
            }

            insertBefore.call(head, newElement, referenceElement);
        };
    };

    MOVE.addWorkaround({
        init: init
    });

}(MOVE || {}));



// WEBPACK FOOTER //
// ./_workarounds/workaround_google_fonts.js